<template>
  <div v-if="showComparePanel" class="fixed bottom-0 right-0 z-20 h-[50px]">
    <VcButton :to="{ name: 'CompareProducts' }" size="lg" class="!min-w-[200px] rounded-none">
      {{ $t("common.links.compare") }}
    </VcButton>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRoute } from "vue-router";
import { useCompareProducts } from "@/shared/compare/composables";

const { productsIds } = useCompareProducts();
const route = useRoute();

const isComparePage = computed<boolean>(() => route.path.includes("compare"));
const showComparePanel = computed<boolean>(() => productsIds.value.length > 0 && !isComparePage.value);
</script>
